import type {
  RechargeDistributionDayData,
  RechargeDistributionParams,
} from './types/recharge-distribution'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { dayjs } from '#/utils'

export const rechargeDistributionApi = defineApi('operation', ({ prefix }) => {
  /**
   * 充值分布曲线
   * POST /gobestads/operation/customerFundChangeDaily/queryRechargeDistribution
   */
  function getRechargeDistribution(params: RechargeDistributionParams) {
    const dateRange = params.dateRange.map((date) =>
      dayjs(date).format('YYYY-MM-DD'),
    )

    return requestClient
      .post<RechargeDistributionDayData[]>(
        prefix('customerFundChangeDaily/queryRechargeDistribution'),
        {
          dateRange,
        },
      )
      .then((res) => {
        // 过滤和格式化数据，确保每个字段都有正确的类型和默认值
        return (res || []).map((item) => ({
          date: item.date,
          totalAmount: item.totalAmount,
          totalAmountDisplay: item.totalAmountDisplay,
          items: (item.items || []).map((item) => ({
            accountType: item.accountType || '',
            amount: item.amount,
            percent: item.percent,
          })),
        }))
      })
  }

  return {
    getRechargeDistribution,
  }
})
